export const colors = [
    '#094081',
    '#0868AC',
    '#2B8CBE',
    '#4EB3D3',
    '#7BCCC4',
    '#A7DDB5',
    '#CCEBC5',
    '#E0F3DB',
    '#EEFCD9',
    '#FBFCF4'
];

export const colorMap = colors.map((color, i) => [i+1, color]);
